import { tokens } from '@fluentui/react-components';
export var AnimTimeConstant = '800ms';
export var EaseAnimation = 'cubic-bezier(0.77, 0, 0.175, 1)';
export var EasyEaseAnimation = 'cubic-bezier(0, 0, 0.04, 0.99)';
export var CarouselHeightDesktop = 500;
export var CarouselWidthDesktop = 850;
export var ColorBrandForeground = tokens.colorBrandForeground1;
export var ColorBrandBackgroundSelected = tokens.colorBrandBackgroundSelected;
export var MediumScreen = 480;
export var LargeScreen = 640;
export var ExtraLargeScreen = 1024;
export var mediaQuery = {
    minMedium: "@media only screen and (min-width: ".concat(MediumScreen, "px)"),
    minLarge: "@media only screen and (min-width: ".concat(LargeScreen, "px)"),
    minExtraLarge: "@media only screen and (min-width: ".concat(ExtraLargeScreen, "px)"),
};
//# sourceMappingURL=Constants.js.map